import Api from 'lib/api';

import { SubmissionError } from 'redux-form';
import { toast } from 'react-toastify';
import { isFunction } from 'lodash';

const api = Api.getInstance();

const ns = 'app/profile/';

export const UPDATE_START = ns + 'UPDATE_START';
export const UPDATE_SUCCESS = ns + 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = ns + 'UPDATE_FAILURE';

export const FETCH_START = ns + 'FETCH_START';
export const FETCH_SUCCESS = ns + 'FETCH_SUCCESS';
export const FETCH_FAILURE = ns + 'FETCH_FAILURE';

export const CHANGE_START = ns + 'CHANGE_START';
export const CHANGE_SUCCESS = ns + 'CHANGE_SUCCESS';
export const CHANGE_FAILURE = ns + 'CHANGE_FAILURE';

export const REMOVE_LOGO = ns + 'REMOVE_LOGO';

export const DELETE_START = ns + 'DELETE_START';
export const DELETE_SUCCESS = ns + 'DELETE_SUCCESS';
export const DELETE_FAILURE = ns + 'DELETE_FAILURE';

export const SOCIAL_LOAD_START = ns + 'SOCIAL_LOAD_START';
export const SOCIAL_LOAD_SUCCESS = ns + 'SOCIAL_LOAD_SUCCESS';
export const SOCIAL_LOAD_ERROR = ns + 'SOCIAL_LOAD_ERROR';

export const SINGLE_SOCIAL_LOAD_START = ns + 'SINGLE_SOCIAL_LOAD_START';
export const SINGLE_SOCIAL_LOAD_SUCCESS = ns + 'SINGLE_SOCIAL_LOAD_SUCCESS';
export const SINGLE_SOCIAL_LOAD_ERROR = ns + 'SINGLE_SOCIAL_LOAD_ERROR';

export const SOCIAL_DELETE_START = ns + 'SOCIAL_DELETE_START';
export const SOCIAL_DELETE_SUCCESS = ns + 'SOCIAL_DELETE_SUCCESS';
export const SOCIAL_DELETE_ERROR = ns + 'SOCIAL_DELETE_ERROR';

export function getProfile(type) {
  return async dispatch => {
    dispatch({
      type: FETCH_START
    });

    try {
      const response = await api.get(`${type}/profile`);
      const { profile } = response.data;

      if (profile) {
        dispatch({
          type: FETCH_SUCCESS,
          payload: profile
        });
      } else {
        dispatch({
          type: FETCH_FAILURE,
          payload: response.data
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      toast.error(response.message);

      dispatch({
        type: FETCH_FAILURE,
        payload: response
      });
    }
  };
}

export function update(type, data, callback) {
  return async dispatch => {
    dispatch({
      type: UPDATE_START
    });

    try {
      const saveData = {
        files: ['meta_datas.logo.value'],
        ...data
      };
      const response = await api.post(`${type}/save`, saveData);
      const { profile, success } = response.data;

      if (callback && isFunction(callback)) {
        callback(success);
      }

      if (success) {
        toast.success('Profile updated!');

        dispatch({
          type: UPDATE_SUCCESS,
          payload: profile
        });
      } else {
        toast.error('Unable to update profile');
        dispatch({
          type: UPDATE_FAILURE,
          payload: response.data
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response.message) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: UPDATE_FAILURE,
        payload: response
      });

      if (response.errors) {
        let throwErrors = {};

        for (let field in response.errors) {
          throwErrors[field] = Object.values(response.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }

      if (callback && isFunction(callback)) {
        callback(false);
      }
    }
  };
}

export function startChangeCard() {
  return {
    type: CHANGE_START
  };
}

export function finishChangeCard() {
  return {
    type: CHANGE_FAILURE,
    payload: null
  };
}

export function changeCard(data) {
  return async dispatch => {
    try {
      const response = await api.post('nonprofits/change-card', data);
      const { customer, success } = response.data;

      if (success) {
        dispatch({
          type: CHANGE_SUCCESS,
          payload: customer
        });

        toast.success('Payment details updated!');

        return;
      }

      toast.error('Unable to update payment details.');

      dispatch({
        type: CHANGE_FAILURE,
        payload: response.data
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response.message) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: CHANGE_FAILURE,
        payload: response
      });
    }
  };
}

export function removeLogo() {
  return {
    type: REMOVE_LOGO
  };
}

export function deleteAccount(callback) {
  return async dispatch => {
    dispatch({
      type: DELETE_START
    });

    try {
      const response = await api.post('users/delete-organization');
      const { success } = response.data;

      if (success) {
        toast.success('Organization deleted!');

        dispatch({
          type: DELETE_SUCCESS
        });

        callback();

        return;
      } else {
        toast.error('Unable to delete organization!');
        dispatch({
          type: DELETE_FAILURE,
          payload: response.data
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response.message) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: DELETE_FAILURE,
        payload: response
      });

      if (response.errors) {
        let throwErrors = {};

        for (let field in response.errors) {
          throwErrors[field] = Object.values(response.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }
    }
  };
}

export function refreshSocialNetworks(callback) {
  return async dispatch => {
    dispatch({
      type: SOCIAL_LOAD_START
    });

    try {
      const response = await api.get('channels');
      const { networks } = response.data;

      dispatch({
        type: SOCIAL_LOAD_SUCCESS,
        payload: networks
      });

      callback();
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response.message) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SOCIAL_LOAD_ERROR,
        payload: response
      });

      callback();
    }
  };
}

export function refreshSocialNetwork(social, callback) {
  return async dispatch => {
    dispatch({
      type: SINGLE_SOCIAL_LOAD_START
    });

    try {
      const response = await api.get(`channels/stats/${social.id}`);
      const { success, network } = response.data;

      if (success) {
        dispatch({
          type: SINGLE_SOCIAL_LOAD_SUCCESS,
          payload: network
        });
      } else {
        dispatch({
          type: SINGLE_SOCIAL_LOAD_ERROR
        });
      }

      callback();
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response.message) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SINGLE_SOCIAL_LOAD_ERROR,
        payload: response
      });

      callback();
    }
  };
}

export function disconnectSocialNetwork(network, callback) {
  return async dispatch => {
    dispatch({
      type: SOCIAL_DELETE_START
    });

    try {
      const response = await api.post(`channels/delete/${network.id}`);
      const { success, data } = response.data;

      dispatch({
        type: success ? SOCIAL_DELETE_SUCCESS : SOCIAL_LOAD_SUCCESS,
        payload: data
      });

      callback();
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response.message) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SOCIAL_DELETE_ERROR,
        payload: response
      });

      callback();
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/app/profile/actions.js